import { createContext, useMemo, ReactNode } from 'react';

// @project
import config from '@/config';
import useLocalStorage from '@/hooks/useLocalStorage';

// @types
import { ConfigContextValue, ConfigStates } from '@/types/config';

/***************************  CONFIG CONTEXT  ***************************/

// eslint-disable-next-line react-refresh/only-export-components
export const ConfigContext = createContext<ConfigContextValue | undefined>(undefined);

/***************************  CONFIG PROVIDER  ***************************/

interface ConfigProviderProps {
  children: ReactNode;
}

export function ConfigProvider({ children }: ConfigProviderProps) {
  const { state, setState, setField, resetState } = useLocalStorage<ConfigStates>('support-toolbox-config', config);

  const memoizedValue = useMemo(() => ({ state, setState, setField, resetState }), [state, setField, setState, resetState]);

  return <ConfigContext.Provider value={memoizedValue}>{children}</ConfigContext.Provider>;
}
